import { styled } from 'linaria/react';

import { BREAKPOINTS, FONTS } from 'styles/constants';

export const StyledWrap = styled.div<{ shouldShow: boolean }>`
  padding: 0 24px 24px;
  transform: translateY(${({ shouldShow }) => (shouldShow ? '0' : '-100%')});
  opacity: ${({ shouldShow }) => (shouldShow ? '1' : '0')};
  max-height: ${({ shouldShow }) => (shouldShow ? '1000px' : '0')};
  overflow: hidden;
  transition: transform 0.3s ease-out, opacity 0.3s ease-out, max-height 0.3s ease-out, padding 0.3s ease-out;
  padding-bottom: ${({ shouldShow }) => (shouldShow ? '24px' : '0')};

  a {
    display: block;
    padding: 12px 0;
    width: fit-content;
  }

  @media screen and (min-width: ${BREAKPOINTS.s}px) {
    padding-left: ${({ shouldShow }) => (shouldShow ? '12px' : '24px')};
    padding-right: ${({ shouldShow }) => (shouldShow ? '12px' : '24px')};
  }
`;

export const StyledTitle = styled.span`
  display: block;
  font-size: 22px;
  word-break: break-word;

  span {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const StyledAnnotation = styled.span`
  font-family: ${FONTS.secondary};
  font-size: 14px;

  span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.with-trancate {
      display: -webkit-box;
      white-space: normal;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  b {
    font-weight: 550;
  }
`;
